import NewsList from "../../components/news/NewsList";

const PageContainer = () => {
  return (
    <div className="w-full px-4 py-9 min-h-screen bg-white md:max-w-[1000px] md:min-h-[calc(100vh_-_180px)]">
      <h1 className="pb-5  text-2xl font-semibold">Новини</h1>
      <p className="pb-10 text-base">
        У «Сільпо» ми завжди допоможемо представникам ЗМІ з інформацією. Читайте
        наші свіжі прес-релізи та, якщо потрібно, звертайтеся до прес-служби в
        будь-який час. e-mail: press@fozzy.ua
      </p>
      <div className="w-full md:flex md:justify-between md:flex-wrap">
        <NewsList />
      </div>
    </div>
  );
};

export default PageContainer;
